<template>
    <nav v-if="visible" class="pkt-tabs" :aria-label="$t('post.page.kind_tabs.aria')">
        <router-link
            v-for="tab in tabs"
            :key="tab.to"
            :to="tab.to"
            class="pkt-tab"
            :class="{ 'is-active': tab.active }"
            :aria-current="tab.active ? 'page' : null"
        >
            <i :class="tab.icon" class="pkt-tab-icon"></i>
            <span class="pkt-tab-label">{{ $t(tab.label) }}</span>
        </router-link>
    </nav>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapState } from 'vuex'
import { hasContributionForms } from '@/helpers/contributionForms'

export default {
    name: 'PostsKindTabs',
    computed: {
        ...mapState('form', {
            allForms: (state) => state.forms
        }),
        /**
         * Sans formulaire de propositions citoyennes, l'onglet n'aurait qu'une
         * seule destination utile : l'écran reste alors tel qu'il était.
         */
        visible() {
            return hasContributionForms(this.allForms)
        },
        tabs() {
            const isContributions = this.$route.name === 'Contributions'
            return [
                {
                    to: '/posts',
                    label: 'menu.tickets.list',
                    icon: 'fal fa-ticket',
                    active: !isContributions
                },
                {
                    to: '/contributions',
                    label: 'menu.tickets.contributions',
                    icon: 'fal fa-lightbulb-on',
                    active: isContributions
                }
            ]
        }
    }
}
</script>

<style scoped>
.pkt-tabs {
    display: flex;
    align-items: stretch;
    gap: var(--v2-space-1, 4px);
    margin-bottom: var(--v2-space-4);
    border-bottom: 1px solid var(--v2-border-subtle);
    overflow-x: auto;
}

.pkt-tab {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border: none;
    border-bottom: 2px solid transparent;
    background: transparent;
    color: var(--v2-text-3);
    font-size: 0.88rem;
    font-weight: var(--v2-font-weight-medium);
    line-height: 1.2;
    white-space: nowrap;
    text-decoration: none;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.pkt-tab:hover {
    color: var(--v2-text-1);
    text-decoration: none;
}

.pkt-tab.is-active {
    color: var(--v2-primary);
    border-bottom-color: var(--v2-primary);
}

.pkt-tab-icon {
    font-size: 0.85rem;
}

@media (max-width: 640px) {
    .pkt-tab {
        flex: 1 1 0;
        justify-content: center;
        padding: 10px 8px;
    }

    .pkt-tab-label {
        font-size: 0.82rem;
    }
}
</style>
